var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSunBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7613 2.515C17.9379 2.50916 18.1152 2.50621 18.2932 2.50621C18.5031 2.50621 18.7121 2.51031 18.92 2.51843C19.037 2.52299 19.1536 2.52883 19.27 2.53593C27.1193 3.01501 33.4191 9.22916 34.0325 17.0415C34.065 17.4549 34.0815 17.8728 34.0815 18.2945H2.50488C2.50488 17.8728 2.52142 17.4549 2.55388 17.0415C3.16645 9.23983 9.44992 3.03198 17.2843 2.53793C17.4114 2.52991 17.5389 2.5234 17.6668 2.51841C17.6983 2.51718 17.7298 2.51605 17.7613 2.515ZM15.8148 3.9697C9.37022 5.07681 4.37595 10.4271 3.81118 17.0415H8.75193C9.89099 11.3868 13.2115 6.72477 15.8148 3.9697ZM10.0318 17.0415H17.9068L17.6891 3.86528C15.1887 6.22101 11.3168 11.0507 10.0318 17.0415ZM18.9439 3.96539L19.1601 17.0415H26.0643C24.8904 11.1345 21.3155 6.35841 18.9439 3.96539ZM27.3404 17.0415H32.7752C32.2069 10.3853 27.1528 5.00919 20.6491 3.94921C23.1213 6.70049 26.2797 11.3732 27.3404 17.0415Z",
    fill: "#0C2487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6666 2.88212V0.751953H18.9197V2.88212H17.6666Z",
    fill: "#0C2487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.17 30.0731V16.415H17.917V30.0731H12.1784L8.54458 22.179H2.78956L8.59936 35.119L7.5489 38.2704L8.73764 38.6666L9.72258 35.7118H28.4425V38.4685H29.6956V35.7118H31.951V30.0731H19.17ZM9.67648 34.4588L4.72569 23.432H7.74196L11.3758 31.3262H30.698V34.4588H9.67648Z",
    fill: "#0C2487"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSunBed);
export default __webpack_public_path__ + "static/media/iconSunBed.c43faa979b8af63e64bcac361d808865.svg";
export { ForwardRef as ReactComponent };